import { render, staticRenderFns } from "./IdeaService.vue?vue&type=template&id=f6ab8c9a&scoped=true"
import script from "./IdeaService.vue?vue&type=script&lang=js"
export * from "./IdeaService.vue?vue&type=script&lang=js"
import style0 from "./IdeaService.vue?vue&type=style&index=0&id=f6ab8c9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ab8c9a",
  null
  
)

export default component.exports